import * as client from './client.js';
import { DEFAULT_SMS_TEST_POLL_TIMEOUT_MS } from '../../../common/defs.js';

const SMS_TEST_CLIENT_TIMEOUT_BUFFER_MS = 5000;
const SMS_TEST_CLIENT_TIMEOUT_MS =
    DEFAULT_SMS_TEST_POLL_TIMEOUT_MS + SMS_TEST_CLIENT_TIMEOUT_BUFFER_MS;

/**
 * Get the currently logged in user.
 */
export async function getCurrentUser() {
    return await client.get('/users/me');
}

/**
 * Retrieve a single user
 */
export async function getUser(id) {
    return await client.get(`/users/${id}`);
}

/**
 * Retrieve a list of user.
 */
export async function getUsersList() {
    return await client.get('/users');
}

/**
 * Delete a user
 */
export async function deleteUser(id) {
    return await client.delete(`/users/${id}`);
}

/**
 * Update a user
 */
export async function saveUser(id, id2, body) {
    return await client.post(`/users/${id}/${id2}`, body);
}

/**
 * Update current user
 */
export async function saveMe(body) {
    return await client.post('/users/me', body);
}

/**
 * Create a new user
 */
export async function addUser(body) {
    return await client.post('/users', body);
}

/**
 * Update password
 */
export async function updatePassword(id, password) {
    return await client.post(`/users/password/${id}`, password);
}

/**
 * Update password
 */
export async function updateMyPassword(password) {
    return await client.post('/users/me/password', password);
}

/**
 * Reset a user's 2FA enrollment and requirement when allowed by org policy.
 */
export async function resetUserTwoFactor(id) {
    return await client.post(`/users/${id}/reset2fa`, {});
}

/**
 * @param {*} data User data
 */
export async function createUser(data) {
    return await client.post('/users', data);
}

/**
 * Update a user
 * @param {number} id User ID for which to set the password
 * @param {*} data User data
 */
export async function updateUser(id, data) {
    return await client.post(`/users/${id}`, data);
}

/**
 * Set the password for a user
 * @param {number} id User ID for which to set the password
 * @param {string} password The new (cleartext) password
 */
export async function setPassword(id, password) {
    return await client.post(`/users/password/${id}`, { password });
}

export async function testSms(number, language) {
    return await client.post(
        '/send_test_sms',
        { number, language },
        AbortSignal.timeout(SMS_TEST_CLIENT_TIMEOUT_MS),
    );
}

export async function testEmail(address, language) {
    return await client.post('/send_test_email', { address, language });
}
